import { render } from "./gameSearch.vue?vue&type=template&id=0e207656"
import script from "./gameSearch.vue?vue&type=script&lang=js"
export * from "./gameSearch.vue?vue&type=script&lang=js"

import "./gameSearch.vue?vue&type=style&index=0&id=0e207656&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__